const trans_en_GB = {
  // Form Fields
  name: "Name",
  first_name: "First Name",
  last_name: "Last Name",
  name_ar: "Name in Arabic",
  name_en: "Name in English",
  price: "Price",
  email: "E-mail",
  password: "Password",
  confirm_password: "Confirm Password",
  phone_number: "Phone Number",
  business_name: "Business Name",
  business_type: "Business Type",
  shop_address: "Shop Address",
  cr_number: "CR Number",
  vat_number: "VAT Number",
  business_logo: "Business Logo",
  image: "Image",
  is_taxable: "Is Taxable",
  is_refunded: "Is Refunded",
  is_qr_product: "Is QR Product",
  is_stockable: "Is Stockable",
  reset: "Reset",
  cart: "Cart",
  address: "Address",
  company: "Company",
  individual: "Individual",
  code: "Code",
  branch_code: "Branch Code",
  branch: "Branch",
  active: "Active",
  inactive: "Inactive",
  subscribe: "Subscribe",
  unsubscribe: "Unsubscribe",
  no_of_employees: "# of Employees",
  no_of_licenses: "# of Licenses",
  vat_certificate: "VAT Certificate",
  cr_certificate: "CR Certificate",
  change: "Change",
  preview: "Preview",
  save: "Save",
  add_license: "Add License",
  purchase_license: "Purchase License",
  add_free_license: "Add Free License",
  buy_more_license: "Buy More Licenses!",
  buy_more_license_error: "Buy more licenses to create more user(s)",
  buyer_company_name: "Buyer Company Name",
  buyer_company_vat: "Buyer Company VAT No.",
  city: "City",
  region: "Region",
  country: "Country",
  postal_code: "Postal Code",
  description: "Description",
  attachment: "Attachment",
  no_attachment: "No Attachment",
  url: "URL",
  secret_key: "Secret Key",
  integration_type: "Integration Type",
  customer_name: "Customer Name",
  vehicle_number: "Vehicle Number",
  vehicle_color: "Vehicle Color",
  reseller_number: "Reseller Number",
  type: "Type",
  street: "Street",
  building_number: "Building Number",
  plot_id_number: "Plot ID Number",
  expiry_date: "Expiry Date",

  // Form Validations
  validate_preferred_contact_time_required:
    "Please choose the preferred contact time.",
  validate_email_required: "The email field is required.",
  validate_email_invalid: "The input is not a valid E-mail!",
  validate_password_required: "The password field is required.",
  validate_password_min_characters: "Password must be at least 6 characters.",
  validate_password_confirm_not_matched: "Confirm password does not match.",
  validate_name_required: "The name field is required.",
  validate_name_min_characters: "Name must be at least 3 characters.",
  validate_first_name_required: "The first name field is required.",
  validate_first_name_min_characters:
    "First name must be at least 3 characters.",
  validate_last_name_required: "The last name field is required.",
  validate_last_name_min_characters: "Last name must be at least 3 characters.",
  validate_phone_required: "The phone number field is required.",
  validate_phone_exact_limit: "Phone number must be exactly 12 digits.",
  validate_business_name_required: "The business name field is required.",
  validate_business_type_required: "Please select a business type.",
  validate_cr_number_required: "CR number is required.",
  validate_cr_number_exact_limit: "CR number must be exactly 10 digits.",
  validate_vat_number_required: "VAT number is required.",
  validate_vat_number_exact_limit: "VAT number must be exactly 15 digits.",
  validate_city_required: "The City field is required.",
  validate_region_required: "The Region field is required.",
  validate_country_required: "The Country field is required.",
  validate_postal_code_required: "The Postal Code field is required.",
  validate_postal_code_5digits: "Postal Code must be exactly 5 digits.",
  validate_address: "The address field is required.",
  validate_shop_address_required: "Please input your Shop Address!",
  validate_image_file_type: "You can only upload JPG/PNG files!",
  validate_photo_file_type: "Photo must be a JPEG, PNG, JPG, GIF, or SVG file!",
  validate_image_size: "Image must be smaller than 2MB!",
  validate_business_logo_required: "Business Logo is required!",
  validate_image_pdf_file_type: "You can only upload JPG/PNG or PDF files!",
  validate_image_size_10: "Image must be smaller than 10MB!",
  validate_cr_certificate_required: "CR Certificate is required!",
  validate_vat_certificate_required: "VAT Certificate is required!",
  validate_type_required: "The Type field is required.",
  validate_excel_file_type: "You can only upload an Excel file!",
  validate_file_size_1: "File must be smaller than 1MB!",
  validate_attachment_required: "The attachment field is required!",
  validate_product_name_required: "Please input the Product name!",
  validate_product_price_required: "Please input the Product price!",
  validate_product_barcode_required: "Please input the Product barcode!",
  validate_product_category_required: "Please select a Product category!",
  validate_product_unit_required: "Please select a Product unit!",
  validate_product_option_required: "Please select a Product Option!",
  validate_address_required: "Please input the Shop Address!",
  validate_branch_required: "Please select a Branch!",
  validate_description_required: "The description field is required.",
  validate_cash_required: "The cash field is required.",
  validate_card_required: "The card field is required.",
  validate_reference_required: "The reference number field is required.",
  validate_discount_required: "The discount percentage is required.",
  validate_url_required: "The URL field is required.",
  validate_url_invalid: "The input is not a valid URL!",
  validate_secret_key_required: "The Secret Key field is required.",
  validate_integration_type_required: "The integration type is required.",
  validate_date_required: "The Date field is required.",
  validate_customer_name_required: "The Customer name field is required.",
  validate_vehicle_number_required: "The Vehicle number field is required.",
  validate_vehicle_color_required: "The Vehicle color field is required.",
  validate_street_required: "The Street field is required.",
  validate_building_number_required: "The Building Number field is required.",
  validate_plot_id_number_required: "The Plot ID Number field is required.",
  validate_entity_required: "This field is required.",
  validate_value_required: "The Value field is required.",
  validate_low_stock_required: "The Low Stock field is required.",
  validate_expiry_date_required: "The Expiry Date field is required.",
  validate_calories_info_required: "Calories info is required.",
  validate_street_name_required: "The Street Name field is required.",
  validate_building_number_4digits: "Building Number must be exactly 4 digits.",
  validate_plot_identification_required: "The Plot ID field is required.",
  validate_plot_identification_4digits: "Plot ID must be exactly 4 digits.",
  validate_district_required: "The District field is required.",
  validate_environment_required: "Please choose an environment.",
  validate_otp_required: "Please enter the OTP.",
  validate_otp_6_digits: "OTP must be exactly 6 digits.",
  validate_buyer_company_name_required: "Buyer company name is required.",
  validate_buyer_company_vat_required: "Buyer company VAT is required.",
  validate_buyer_company_address_required: "Buyer company address is required.",
  validate_arabic_name_required: "Arabic name is required.",
  validate_sa_vat_number:
    "VAT number must be 15 digits and start and end with 3.",

  // Login
  dont_have_account: "Don't have an account?",
  login: "Login",
  visit_website: "Visit website",
  website: "Website",

  // Register
  already_have_an_account: "Already have an account?",
  sign_in: "Sign in",
  sign_up: "Sign up",
  register_successfully: "You have been registered successfully!",
  selected_plan: "Selected Plan",
  account_successfully_created: "Your account has been successfully created!",
  details_activate_company:
    "Fill in the details to activate your company or skip for now.",

  // Forgot
  forgot: "Forgot password",
  send_otp: "Send OTP",
  verify_otp: "Verify OTP",
  reset_password: "Reset password",
  reset_password_successfully: "Your password has been reset successfully!",

  // Pricing
  daily: "Daily",
  trial: "Trial",

  // otp form
  opt_message:
    "A message with the OTP code has been sent to your mobile number. Kindly fill it in the field below and validate.",
  if_you_want_to_change_phone_number:
    "If you want to change your phone number,",
  click_here: "Click Here.",
  resend_code: "Resend Code",
  enable_in: "Enable in",
  validate: "Validate",
  otp_sent_successfully: "OTP sent successfully!",
  otp_verified: "OTP verified successfully!",

  // Store Configuration
  shop_configuration_successfully: "Shop configuration has been completed.",
  allow_round_off: "Allow round off to 2 digits",
  preferred_contact_time: "Preferred contact time",

  // Menus
  home: "Home",
  pos: "POS",
  products_list: "Products list",
  products: "Products",
  categories: "Categories",
  units: "Units",
  options: "Options",
  transactions: "Transactions",
  reports: "Reports",
  sales_summary: "Sales Summary",
  sales_by_items: "Sales By Items",
  sales_by_categories: "Sales By Categories",
  refunds_by_items: "Refunds By Items",
  refunds_by_categories: "Refunds By Categories",
  report_by_branch: "Report By Branch",
  store_configuration: "Store Configuration",
  subscriptions: "Subscriptions",
  branches: "Branches",
  orders: "Orders",
  view_order: "View Order",
  edit_order: "Edit Order",
  tables: "Tables",
  employees: "Employees",
  invoices: "Invoices",
  help_desk: "Help Desk",
  discounts: "Discounts",
  external_integration: "External Integration",
  addons: "Addons",
  addon_detail: "Addon Detail",
  inventory: "Inventory",
  stock: "Stock",
  stock_overview: "Stock Overview",
  stock_adjustment: "Stock Adjustment",
  view_stock_adjustment: "View Stock Adjustment",
  stock_transfer: "Stock Transfer",
  view_transfer: "View Transfer",
  edit_transfer: "Edit Transfer",
  customers: "Customers",
  customer_details: "Customer Details",
  sales_invoice: "A4 Sales Invoice",
  view_sales_invoice: "View A4 Sales Invoice",
  tax_configuration: "Tax Configuration",

  // Products
  product_add: "Add Product",
  product_added: "Product Added",
  product_added_successfully: "Product has been added successfully!",
  product_edit: "Edit Product",
  product_updated: "Product Updated",
  product_updated_successfully: "Product has been updated successfully!",
  product_deleted: "Product Deleted",
  product_deleted_successfully: "Product has been deleted successfully!",
  products_import: "Import Products",
  products_import_successfully: "Products have been imported successfully!",

  // Product Categories
  category_add: "Add Category",
  category_name: "Category Name",
  category_edit: "Edit Category",
  category_name_required: "Please input product category name!",
  category_added: "Category Added",
  category_added_successfully: "Category has been added successfully!",
  category_updated: "Category updated",
  category_updated_successfully: "Category has been updated successfully!",
  category_deleted: "Category Deleted",
  category_deleted_successfully: "Category has been deleted successfully!",
  categories_import: "Import Categories",
  categories_import_successfully: "Categories have been imported successfully!",

  // Product Units
  unit_add: "Add Unit",
  unit_name: "Unit Name",
  unit_edit: "Edit Unit",
  unit_name_required: "Please input product unit name!",
  unit_added: "Unit Added",
  unit_added_successfully: "Unit has been added successfully!",
  unit_updated: "Unit Updated",
  unit_updated_successfully: "Unit has been updated successfully!",
  unit_deleted: "Unit Deleted",
  unit_deleted_successfully: "Unit has been deleted successfully!",
  units_import: "Import Units",
  units_import_successfully: "Units have been imported successfully!",

  // Product Options
  option_add: "Add Option",
  option_name: "Option Name",
  option_edit: "Edit Option",
  option_name_required: "Please input product Option name!",
  option_added: "Option Added",
  option_added_successfully: "Option has been added successfully!",
  option_updated: "Option Updated",
  option_updated_successfully: "Option has been updated successfully!",
  option_deleted: "Option Deleted",
  option_deleted_successfully: "Option has been deleted successfully!",
  select_options: "Select Options",

  // Branches
  branch_add: "Add Branch",
  branch_added: "Branch Added",
  branch_added_successfully: "Branch has been added successfully!",
  branch_deleted: "Branch Deleted",
  branch_deleted_successfully: "Branch has been deleted successfully!",
  branch_edit: "Edit Branch",
  branch_updated: "Branch Updated",
  branch_updated_successfully: "Branch has been updated successfully!",

  // Customers
  customer_add: "Add Customer",
  customer_added: "Customer Added",
  customer_added_successfully: "Customer has been added successfully!",
  customer_deleted: "Customer Deleted",
  customer_deleted_successfully: "Customer has been deleted successfully!",
  customer_edit: "Edit Customer",
  customer_updated: "Customer Updated",
  customer_updated_successfully: "Customer has been updated successfully!",

  // Orders
  mark_as_in_progress: "Mark as In Progress",
  mark_as_complete: "Mark as Complete",
  add_order: "Add Order",
  cancel_order: "Cancel Order",
  order_added: "Order Added",
  order_added_successfully: "The order has been added successfully!",
  order_updated: "Order Updated",
  order_updated_successfully: "The order has been updated successfully!",

  // Tables
  table_added: "Table Added",
  table_added_successfully: "Table has been added successfully!",
  drive_thru: "Drive-Through",
  drive_thru_add: "Add Drive-Through",
  drive_thru_added: "Drive-Through Added",
  drive_thru_added_successfully: "Drive-Through has been added successfully!",
  entity_updated: "Entity Updated",
  entity_updated_successfully: "Entity has been updated successfully!",
  entity_deleted: "Entity Deleted",
  entity_deleted_successfully: "Entity has been deleted successfully!",
  add_table: "Add Table",
  update_table: "Update Table",
  assign_table_to_order: "Assign Table to Order",
  select_table: "Select Table",
  validate_table_required: "The Table field is required.",

  // Employees
  employee_add: "Add Employee",
  employee_added: "Employee Added",
  employee_added_successfully: "Employee has been added successfully!",
  employee_edit: "Edit Employee",
  employee_updated: "Employee Updated",
  employee_updated_successfully: "Employee has been updated successfully!",
  employee_activate: "Activate Employee",
  employee_activated: "Employee Activated",
  employee_activated_successfully: "Employee has been activated successfully!",
  employee_deactivate: "Deactivate Employee",
  employee_deactivated: "Employee Deactivated",
  employee_deactivated_successfully:
    "Employee has been deactivated successfully!",
  employee_deleted: "Employee Deleted",
  employee_deleted_successfully: "Employee has been deleted successfully!",

  // Helpdesk
  ticket_add: "Add Ticket",
  ticket_added: "Ticket Added",
  ticket_added_successfully: "The ticket has been added successfully!",
  ticket_updated: "Ticket Updated",
  ticket_updated_successfully: "The ticket has been updated successfully!",

  // Discount
  discount_add: "Add Discount",
  discount_added: "Discount Added",
  discount_added_successfully: "Discount has been added successfully!",
  discount_deleted: "Discount Deleted",
  discount_deleted_successfully: "Discount has been deleted successfully!",
  discount_edit: "Edit Discount",
  discount_updated: "Discount Updated",
  discount_updated_successfully: "Discount has been updated successfully!",

  // External Integration
  connection_add: "Add Connection",
  connection_update: "Update Connection",
  connection_added: "Connection Added",
  connection_added_successfully: "Connection has been added successfully!",
  connection_test: "Test connection",
  connection_tested_successfully: "Connection has been tested successfully!",
  connection_tested_failed:
    "Connection test failed due to invalid credentials!",
  connection_save: "Save connection",
  connection_saved_successfully: "Connection has been saved successfully!",
  connection_saved_failed: "Connection save failed due to invalid credentials!",
  connection_deleted: "Connection Deleted",
  connection_deleted_successfully: "Connection has been deleted successfully!",

  // Addon
  addon_subscribed: "Addon subscribed",
  addon_subscribed_successfully: "Addon subscribed successfully!",
  addon_unsubscribed: "Addon Unsubscribed",
  addon_unsubscribed_successfully: "Addon unsubscribed successfully!",
  subscribe_dependent_addons:
    "Please subscribe to these addons first: {{addons}}",
  unsubscribe_dependency_warning:
    "If you unsubscribe the {{addon}} addon, these addons may also be unsubscribed automatically from your account.",
  addon_filter_all_modules: "All Modules",
  addon_available: "Available",
  addon_requires: "Requires",
  addon_used_by: "Used by",
  addon_whats_included: "What's included",
  addon_access: "Access",
  addon_daily_price_after_trial: "Daily price after trial",
  addon_available_with_current_setup: "Available with your current setup",
  addon_charged_only_when_in_use: "Charged only when this addon is in use",
  addon_always_on: "Always on",
  addon_trial_days_label: "Trial days",
  addon_currently_active: "Currently active",
  addon_ready_to_activate: "Ready to activate",
  addon_free_access: "Free access",
  addon_daily_billed_module: "Daily billed module",
  addon_no_trial_period: "No trial period",
  addon_required_addons_count: "{{count}} required addon",
  addon_required_addons_count_other: "{{count}} required addons",
  addon_no_dependency_required: "No dependency required",
  addon_used_by_addons_count: "Used by {{count}} addon",
  addon_used_by_addons_count_other: "Used by {{count}} addons",
  addon_standalone_setup: "Standalone setup",
  addon_free_trial_days: "{{days}} day free trial",
  addon_always_free: "Always free",
  addon_no_trial_included: "No trial included",
  addon_per_day: "/ day",
  no_addons_found: "No addons found",

  // invoices
  model: "Model",
  imei: "IMEI",
  serial_no: "Serial No.",
  due_amount: "Due Amount",
  installments: "Installments",
  warranty_from_to: "Warranty From - To",
  warranty_starting_at: "Warranty Start",
  warranty_ending_at: "Warranty End",
  user_licenses_added: "User Licenses Added",
  user_licenses_have_been_added_successfully:
    "User Licenses have been added successfully!",

  // topup
  wallet_details: "Wallet Details",
  available_credit: "Available credit",
  topup: "Top-up",
  balance_validity: "Balance Validity",
  topup_request_received: "Top-up request received",
  topup_request_received_successfully: "Top-up request received successfully!",
  confirmation: "Confirmation",
  check_confirmation_checkbox: "Kindly check the confirmation checkbox!",
  enter_topup_amount: "Enter top-up amount",
  enter_reference_no: "Enter reference no.",
  minimum_topup_amount_required: "Minimum top-up amount required",
  your_balance_is_low_please_recharge_minimum:
    "Your balance is low. Please recharge the minimum amount.",

  // Waiter component
  waiter: "Waiter",
  add_waiter: "Add Waiter",
  is_waiter: "Is Waiter",
  update_waiter: "Update Waiter",
  waiter_updated: "Waiter Updated",
  assign_waiter_to_order: "Assign Waiter to Order",
  select_waiter: "Select Waiter",
  validate_waiter_required: "The waiter field is required.",
  waiter_not_available_for_branch:
    "Selected waiter is not available for this branch.",
  no_waiter_found_for_branch: "No waiter found for this branch.",

  // job management component
  job_person: "Job Person",
  is_job_person: "Is Job Person",
  select_job_person: "Select Job Person",
  job_person_updated: "Job Person Updated",
  update_job_person: "Update Job Person",
  validate_job_person_required: "The Job person is required.",

  // Inventory component
  adjustment_add: "Add Adjustment",
  stock_adjustment_done: "Stock adjustment done",
  stock_adjustment_done_successfully:
    "Stock adjustment has been completed successfully!",
  adjustment_history: "Adjustment History",
  direct_transfer: "Direct Transfer",
  request_transfer: "Request Transfer",
  cancel_transfer: "Cancel Transfer",
  accept_transfer: "Accept Transfer",
  reject_transfer: "Reject Transfer",
  confirm_transfer: "Confirm Transfer",
  transfer_added: "Transfer Added",
  transfer_added_successfully: "Transfer has been added successfully!",
  transfer_updated: "Transfer Updated",
  transfer_updated_successfully: "Transfer has been updated successfully!",

  // Sales Invoice
  invoice_add: "Add Invoice",
  invoice_added: "Invoice Added",
  invoice_added_successfully: "Invoice has been added successfully!",
  invoice_updated: "Invoice Updated",
  invoice_updated_successfully: "Invoice has been updated successfully!",
  invoice_edit: "Edit Invoice",
  invoice_deleted: "Invoice Deleted",
  invoice_deleted_successfully: "Invoice has been deleted successfully!",
  save_as_draft: "Save as Draft",
  issue_invoice: "Issue Invoice",
  register_payment: "Register Payment",

  // Tax
  tax: "Tax",
  tax_add: "Add Tax",
  tax_added: "Tax Added",
  tax_added_successfully: "Tax has been added successfully!",
  tax_updated: "Tax Updated",
  tax_updated_successfully: "Tax has been updated successfully!",
  tax_edit: "Edit Tax",
  tax_deleted: "Tax Deleted",
  tax_deleted_successfully: "Tax has been deleted successfully!",
  select_taxes: "Select Taxes",

  // Ticketing
  tickets: "Tickets",
  is_ticket: "Is Ticket",
  issue_ticket: "Issue Ticket",
  print_ticket: "Print Ticket",
  ticket_issue_failed: "Ticket issue failed. Please try again.",
  no_unissued_ticket_found: "No unissued ticket found for this transaction.",
  person_one: "Person",
  person_other: "Persons",
  not_scanned: "Not Scanned",
  partially_scanned: "Partially Scanned",
  fully_scanned: "Fully Scanned",

  // Table Columns
  product: "Product",
  category: "Category",
  unit: "Unit",
  option: "Option",
  barcode: "Barcode",
  amount: "Amount",
  quantity: "Quantity",
  status: "Status",
  created_at: "Created At",
  created_by: "Created by",
  paid_at: "Paid At",
  subtotal: "SubTotal",
  sold_quantities: "Sold Quantities",
  gross_sales: "Gross Sales",
  refund_quantities: "Refund Quantities",
  gross_refund: "Gross Refunds",
  start_date: "Start Date",
  end_date: "End Date",
  date: "Date",
  subscription_plan: "Subscription Plan",
  transaction_id: "Transaction ID",
  discount_percentage: "Discount Percentage",
  invoice_id: "Invoice ID",
  subscription: "Subscription",
  license: "License",
  total_amount_charged: "Total Amount Charged",
  items: "Items",
  user: "User",
  payment: "Payment",
  new: "New Tickets",
  inprogress: "Tickets In Progress",
  done: "Tickets Done",
  closed: "Tickets Closed",
  allow_refund: "Allow Refund",
  allow_add_products: "Allow Add Products",
  allow_edit_products: "Allow Edit Products",
  source: "Source",
  pending_orders: "Pending Orders",
  inprogress_orders: "In-Progress Orders",
  completed_orders: "Completed Orders",
  cancelled_orders: "Cancelled Orders",
  branch_from: "Branch From",
  branch_to: "Branch To",
  draft_invoices: "Draft Invoices",
  open_invoices: "Open Invoices",
  partially_paid_invoices: "Partially Paid Invoices",
  paid_invoices: "Paid Invoices",
  balance: "Balance",
  due_date: "Due Date",
  low_stock: "Low Stock",

  // Reports
  net_sales: "Net Sales",
  total_sales: "Total Sales",
  refunds: "Refunds",
  sales: "Sales",
  payments: "Payments",
  net_total: "Net Total",
  total_refunds: "Total Refunds",
  total: "Total",
  vat: "VAT",
  taxes_on_sale: "Taxes on Sale",
  total_taxes_on_sale: "Total Taxes on Sale",
  quarterly_tax: "Tax on Quarterly Sales",
  payment_types: "Payment Types",
  quarterly_sales: "Quarterly Sales",
  sales_overview: "Sales Overview",

  // Warnings
  warning_remove: "Are you sure you want to remove this entity?",
  warning_delete: "Are you sure you want to delete this entity?",
  warning_logout: "Are you sure you want to logout?",
  warning_empty_basket:
    "Are you sure you want to delete these products from the basket?",
  warning_remove_product:
    "Are you sure you want to delete this product from the basket?",
  warning_delete_stock_product:
    "Please note: if you delete this product, its stock will be deleted automatically.",
  warning_unsubscribe_addon:
    "If you unsubscribe from the addon, the data will be removed from the server after 3 days.",

  // Status
  status_paid: "PAID",
  status_refunded: "REFUNDED",

  // Miscellaneous
  yes: "Yes",
  no: "No",
  logout: "Logout",
  logging_out: "Logging out...",
  cancel: "Cancel",
  add: "Add",
  edit: "Edit",
  update: "Update",
  submit: "Submit",
  confirm: "Confirm",
  search: "Search",
  upload: "Upload",
  back: "Back",
  order_id: "Order ID",
  order_details: "Order Details",
  issued_at: "Issued At",
  date_range: "Date Range",
  delete_entity: "Delete Entity",
  something_went_wrong: "Something went wrong",
  refund: "Refund",
  user_can_edit_price_on_pos: "User Can Edit Price on POS",
  user_can_apply_discount: "User Can Apply Discount",
  user_see_transactions: "User Can See the Transactions",
  user_can_refund_transaction: "User Can Refund Transaction",
  user_can_add_edit_products: "User Can Add and Edit the Products",
  user_can_request_stock_transfer: "User Can Request Stock Transfer",
  user_can_approve_stock_transfer: "User Can Approve Stock Transfer",
  user_allowed_stock_adjustment: "User is Allowed to do Stock Adjustment",
  user_can_add_edit_customers: "User Can Add and Edit the Customers",
  user_can_view_customers: "User Can View the Customers",
  user_can_add_pay_sales_invoices: "User Can Add and Pay A4 Sales Invoices",
  user_can_view_sales_invoices: "User Can View A4 Sales Invoices",
  user_can_scan_view_ticket: "The user can scan and view the ticket",
  user_can_manage_zatca: "User can manage ZATCA E-Invoicing",
  is_machine_user: "Is Machine User",
  proceed: "Proceed",
  checkout: "Checkout",
  payment_type: "Payment Type",
  cash_collected: "Cash Collected",
  reference_no: "Reference No.",
  collected_by_cash: "Collected by Cash",
  collected_by_card: "Collected by Card",
  charged_amount: "Charged Amount",
  ask_more_cash: "Ask for more cash before proceeding!",
  return_back_amount: "Return Back",
  collect_more_cash: "Collect More Cash",
  print: "Print",
  print_bill: "Print Bill",
  print_invoice: "Print Invoice",
  declaration: "Declaration",
  declaration_text:
    "I hereby declare that the information provided in this form is accurate and complete. I confirm that if any information is found to be incorrect and/or incomplete, leading to a violation of regulations, it may initiate legal actions. I accept that I am the responsible party for any and all charges, penalties, and violations.",
  stc_pay_declaration_text:
    "I hereby declare that the STC Pay reference ID provided in this form is accurate and complete. Your balance will be shown on your dashboard within one working day.",
  upgrade: "Upgrade",
  upgrade_subscription: "Upgrade Subscription",
  payment_successful: "Payment Successful!",
  your_payment_successfully: "Your payment has been successful.",
  payment_failed: "Payment Failed!",
  try_again_payment_failed: "Your payment has failed. Please try again.",
  all: "All",
  cart_empty: "Your Cart is empty.",
  total_amount: "Total Amount",
  licenses: "License(s)",
  purchase: "Purchase",
  credit_card: "Credit Card",
  stc_pay: "STC Pay",
  mada: "MADA",
  cash: "Cash",
  card: "Card",
  bank: "Bank",
  multi_payment: "Multi Payment",
  plz_fill_details: "Please fill in the details below to proceed",
  billing_details: "Billing Details",
  business_address_details: "Business Address Details",
  discount: "Discount",
  select_a_discount: "Select a Discount",
  unpaid_invoice: "Unpaid Invoice!",
  pay_your_invoice: "Kindly pay your unpaid invoice",
  show_invoices: "Show Invoices",
  what_type_of_refund: "What type of refund do you want to perform?",
  full: "Full",
  partial: "Partial",
  refund_amount: "Refund Amount",
  zatca_refund_reason_required: "ZATCA refund reason required",
  zatca_refund_reason_helper:
    "This transaction was created as a ZATCA invoice. Select the reason that should be sent with the refund credit note.",
  select_zatca_refund_reason: "Select refund reason",
  zatca_refund_reason_cancellation_suspension: "Cancellation/Suspension",
  zatca_refund_reason_goods_services_refund: "Goods/Services Refund",
  zatca_refund_reason_price_reduction_discount: "Price Reduction/Discount",
  zatca_refund_reason_invoice_errors: "Invoice Errors",
  zatca_refund_reason_change_in_information: "Change in Information",
  qty: "Qty",
  additional_info: "Additional Info",
  users: "Users",
  action: "Action",
  pay_now: "Pay Now",
  view_invoice: "View Invoice",
  one_time_payment: "One Time Payment",
  complete: "Complete",
  incomplete: "Incomplete",
  max_upload_size_10mb_warning: "Max upload size: 10MB",
  max_upload_size_2mb_warning: "Max upload size: 2MB",
  account_under_verification: "Your account is under verification!",
  notified_once_verified:
    "Thank you for signing up. You will be notified on your mobile number once your account is verified.",
  account_blocked: "Your account is blocked!",
  kindly_contact_at: "Kindly contact us at contact@anypos.ai",
  is_vat_exempt: "I don't have a VAT certificate",
  vat_exempt_latter_sample: "VAT exempt letter sample",
  vat_exempt_latter: "VAT Exempt Letter",
  connection: "Connection",
  connected: "Connected",
  disconnected: "Disconnected",
  download_report: "Download report",
  download_sales_report: "Download sales report",
  download_payments_report: "Download payments report",
  download_template: "Download Template",
  skip: "Skip",
  fill_the_details: "Fill in the Details",
  kindly_complete_the_store_details_within:
    "Kindly complete the store details within",
  days_otherwise_your_account_will_be_blocked:
    "days, otherwise your account will be blocked.",
  unlimited: "Unlimited",
  per_user: "Per User",
  payment_modal: "Payment Modal",
  select_payment_method: "Select Payment Method",
  service_name: "Service Name",
  subscriptions_history: "Subscriptions History",
  spending_history: "Spending History",
  trial_days: "Trial Days",
  paid: "Paid",
  unpaid: "Unpaid",
  qr: "QR",
  dining_table: "Dining Table",
  note: "Note",
  clear: "Clear",
  selected_item: "Selected Item",
  pending: "Pending",
  completed: "Completed",
  cancelled: "Cancelled",
  refunded: "Refunded",
  recharge_request: "Recharge Request",
  rejected: "Rejected",
  available_stock: "Available Stock",
  requested_stock: "Requested Stock",
  current_stock: "Current Stock",
  your_branch: "Your Branch",
  approved_quantity: "Approved Quantity",
  requested_quantity: "Requested Quantity",
  insufficient_quantity: "Insufficient Quantity",
  out_of_stock: "Out of Stock",
  product_already_selected: "Product already Selected",
  basket: "Basket",
  search_product_name_here: "Search product name here",
  welcome_to: "Welcome to",
  call_to_waiter: "Call Waiter",
  order: "Order",
  select_language: "Select Language",
  place_order: "Place Order",
  basket_empty: "Your basket is empty!",
  menu: "Menu",
  order_placed_successfully: "Your order has been placed successfully!",
  hi: "Hi",
  welcome_anypos: "Welcome to AnyPOS!",
  place_new_order: "Place New Order",
  your_order: "Your Order",
  expired: "Expired",
  is_expired: "Is Expired",
  late_payment: "Late Payment",
  is_late_payment: "Is Late Payment",
  addon_selected: "Addon Selected",
  all_prices_daily_basis: "All the prices are on a daily basis.",
  we_only_charge_use_addon: "We will only charge if you use the addon.",
  free: "Free",
  free_trial: "Free in Trial",
  need_addons: "Need Addons?",
  value: "Value",
  taxes: "Taxes",
  total_without_tax: "Total without tax",
  price_including_tax: "Price including tax",
  total_taxes: "Total Taxes",
  total_with_tax: "Total with tax",
  branch_selling_products: "Branch Selling Products",
  filters: "Filters",
  sales_insight: "Sales Insight",
  disabled: "Disabled",
  after_trials: "After Trials Per Day",
  cannot_select_table_management_while_job_management_is_active:
    "Cannot select Table Management while Job Management is active.",
  cannot_select_job_management_while_waiter_management_or_table_management_is_active:
    "Cannot select Job Management while Waiter Management or Table Management is active.",
  cannot_select_waiter_management_while_job_management_is_active:
    "Cannot select Waiter Management while Job Management is active.",
  dependent_addons: "Dependent Addons",
  successfully_added: "Successfully Added",
  generate_ai_image_for_one_product: "Generate AI Image for 1 Product",
  generate_ai_images_for_products: "Generate AI Images for {{count}} Products",
  generating_images_with_ai: "Generating images with AI for {{count}} products",
  image_generated: "Image Generated",
  image_generated_successfully: "Image has been generated successfully!",
  images_generated: "Images Generated",
  images_generated_successfully:
    "Images for {{count}} products have been generated successfully!",
  images_generation_started: "AI image generation started",
  images_generation_started_desc:
    "Images for {{count}} products are being generated in the background.",
  images_generation_failed: "Image generation failed",
  images_generation_completed_with_errors:
    "{{completed}} images generated, {{failed}} failed.",
  products_already_have_images: "Selected products already have images.",
  image_generation_live_updates_unavailable:
    "Live updates are unavailable; generated images will appear the next time the products list loads.",
  Showing_transactions_from_all_branches:
    "Showing transactions from all branches",
  Showing_transactions_from_my_branch: "Showing transactions from my branch",
  all_data: "All Data",
  branch_data: "Branch Data",
  Showing_orders_from_all_branches: "Showing orders from all branches",
  Showing_orders_from_my_branch: "Showing orders from my branch",
  total_stock: "Total Stock",
  branch_stock: "Branch Stock",
  view_all: "View All",
  photo: "Photo",
  nationality: "Nationality",
  id_number: "ID Number",
  products_by_category: "Products by Category",
  view_details: "View Details",
  how_would_you_like_to_order: "How would you like to order?",
  order_with_ai: "Order with AI",
  order_yourself: "Order yourself",
  no_menu_data_found: "No menu data found",
  please_scan_valid_qr_code_or_try_again_later:
    "Please scan a valid QR code or try again later.",
  order_mode: "Order Mode",
  change_mode: "Change Mode",
  powered_by_anypos: "Powered by AnyPOS",
  is_calories: "Show Calories",
  calories_info: "Calories Info",

  calories: "Calories",
  configuration: "Configuration",
  trial_addons_expiring_today: "Your add-ons trial ends today",
  trial_addons_message:
    "These add-ons are currently on trial and will expire today. If you choose to keep them, the add-on charges will start from tomorrow and your balance will be deducted. Do you want to keep them or unsubscribe?",
  trial_ends_today: "Trial ends today",
  unsubscribe_all_addons: "Unsubscribe all",
  keep_addons: "Keep addons",
  needs: "Needs",
  affects: "Affects",
  addon_needs_title: "This addon needs other addons",
  addon_needs_description:
    "To keep {{addon}} active, the following addons must also remain enabled:",
  addon_affects_title: "Removing this addon will affect other features",
  addon_affects_description:
    "If you disable {{addon}}, the following addons will also be disabled because they depend on it:",
  addons_updated: "Addons updated",
  addons_updated_successfully:
    "Your addon preferences have been updated successfully!",
  also_disabled_depends_on: "will also be disabled because it depends on",
  addon_depends_on_message:
    "{{addon}} depends on {{addons}}. Please select {{target}} first.",
  addon_remove_affects_message:
    "{{addons}} {{verb}} on {{addon}}. {{pronoun}} will be removed as well.",

  depend: "depend",
  depends: "depends",
  it: "It",
  these: "These",
  that: "that",
  those: "those",
  generating_image_with_ai:
    "Please wait. We are creating the best image for you.",
  please_wait_a_moment: "Please wait a moment",
  addon_needs_short: "{{addon}} needs these addons to work.",
  addon_affects_short:
    "If you disable {{addon}}, these addons may be disabled too.",

  customer_display: "Customer Display",
  product_expired: "Product Expired",
  dine_in: "Dine In",
  takeaway: "Takeaway",

  kitchen_status: "Kitchen Status",
  awaiting: "Awaiting",
  preparing: "Preparing",
  cooked: "Cooked",
  order_type: "Order Type",

  display_screens: "Display Screens",
  last_seen: "Last Seen",
  bound_by: "Bound By",
  unbind_this_device: "Unbind this device?",
  unbind_pos_and_cds: "Unbind POS and linked CDS?",
  device_added: "Device Added",
  device_added_successfully: "Device has been added successfully!",
  device_unbind: "Device Unbind",
  device_unbind_successfully: "Device has been unbound successfully!",
  add_kitchen_screen: "Add Kitchen Screen",
  add_customer_screen: "Add Customer Screen",
  generate_code: "Generate Code",

  customer_display_screen: "Customer Display Screen",
  register_pos_terminal: "Register POS Terminal",
  pos_terminal: "POS Terminal",
  expires_in: "Expires in",
  register_pos_terminal_first: "Register POS Terminal first",
  enter_pairing_code_instruction:
    "Enter this pairing code on the Display Screen. It expires in ",
  pairing_code_expired_message:
    "This pairing code has expired. Please generate a new code.",
  linked_pos_uid: "Linked POS UID",
  not_registered: "Not Registered",

  kitchen_display_screens: "Kitchen Display Screens",
  kitchen_display_screen: "Kitchen Display Screen",

  pos_terminal_already_registered:
    "POS terminal is already registered. Unbind it first.",
  open_screen_device_url_instruction:
    "Open this URL on the screen device, then enter the OTP:",

  takeaway_cancel_refund_warning:
    "If you cancel this takeaway order, the order will be refunded automatically.",

  transaction_refunded: "Transaction Refunded",
  transaction_refunded_successfully:
    "Transaction has been refunded successfully!",
  cancel_order_before_refund:
    "To refund this order, you need to cancel the order first.",
  ok: "OK",

  pricing_badge:
    "{{days}}-day free trial on selected modules · No credit card required",
  simple_pricing: "Simple pricing.",
  pay_only_for_what_you_use: "Pay only for what you use.",
  pricing_hero_desc:
    "Start free. Top up when ready. Only pay on the days you're open—never a flat subscription that drains your account.",
  pricing_free_trial_included: "{{days}}-day free trial included",
  pricing_trial_desc: "{{addons}} are free for {{days}} days. No commitment.",

  how_many_users: "How many users?",
  pos_users: "POS Users",
  pricing_users_desc:
    "Each user = SAR {{amount}} per active day · Only charged when they log in",
  per_day: "PER DAY",

  included_in_every_plan: "Included in every plan",
  point_of_sale: "Point of Sale",
  zatca_invoicing: "ZATCA Invoicing",
  customer_database: "Customer Database",
  multi_branch: "Multi-branch",
  products_catalogue: "Products Catalogue",
  sales_reports: "Sales Reports",
  tap_to_pay: "Tap to Pay",
  business_types: "Business Types",

  choose_your_modules: "Choose your modules",
  included_in_this_group: "Included in this group",
  pricing_no_extra_dependency: "No extra dependency",

  your_plan_summary: "Your plan summary",
  daily_total: "Daily total",
  daily_subscription_plan_unavailable:
    "The daily subscription plan is currently unavailable. Please try again later.",
  pricing_after_trial_note: "After {{days}}-day trial · only on active days",
  included: "Included",
  start_free_trial: "Start Free Trial",
  pricing_cta_line_1:
    "{{days}}-day trial on paid modules · No credit card required",
  pricing_cta_line_2: "Pay SAR {{amount}}/day + VAT after trial",

  complete_signup_details:
    "Complete your business details to activate your free trial.",
  otp_verify_subtitle: "Enter the code sent to your mobile number to continue.",

  pricing_group_fnb_title: "Café, Restaurant & Food Business",
  pricing_group_fnb_desc:
    "Order, table, kitchen and waiter management for food businesses",

  pricing_group_job_title: "Maintenance, Car Wash & Delivery",
  pricing_group_job_desc: "Job and task tracking for field service teams",

  pricing_group_stock_title: "Stock Management",
  pricing_group_stock_desc:
    "Real-time inventory tracking, low stock alerts, product catalog",

  pricing_group_ticket_title: "Ticketing",
  pricing_group_ticket_desc:
    "Sell and scan tickets for events, parking, shows, and attractions",

  popup_pos_eyebrow: "POS Users — Included Features",
  popup_pos_title: "Works for any business that sells",
  popup_pos_desc:
    "The base POS plan includes everything you need to run daily sales, issue ZATCA-compliant invoices, and manage customers — no additional modules required.",

  popup_fnb_title: "Built for food & beverage operations",
  popup_fnb_desc:
    "This module adds table management, waiter assignment, QR ordering, kitchen display, and customer display — all the tools a food business needs to run smoothly.",

  popup_job_title: "For field service & task-based businesses",
  popup_job_desc:
    "This module lets you assign jobs to technicians, track task progress in real time, and manage customer service visits — from first booking to completion.",

  popup_stock_title: "Any business with physical inventory",
  popup_stock_desc:
    "Track what you have, get alerts when stock runs low, and manage products across multiple branches — works with any business type.",

  industry_gold_jewelry: "Gold & Jewelry Shops",
  industry_clothing_fashion: "Clothing & Fashion",
  industry_pharmacies: "Pharmacies",
  industry_grocery_supermarkets: "Grocery & Supermarkets",
  industry_cosmetics_beauty: "Cosmetics & Beauty",
  industry_electronics_phones: "Electronics & Phones",
  industry_furniture_home: "Furniture & Home",
  industry_laundry_dry_clean: "Laundry & Dry Clean",
  industry_salons_barbershops: "Salons & Barbershops",
  industry_any_retail_business: "Any Retail Business",

  industry_cafes_coffee_shops: "Cafés & Coffee Shops",
  industry_dine_in_restaurants: "Dine-In Restaurants",
  industry_fast_food_qsr: "Fast Food & QSR",
  industry_food_courts: "Food Courts",
  industry_bakeries_desserts: "Bakeries & Desserts",
  industry_healthy_food_outlets: "Healthy Food Outlets",
  industry_drive_through: "Drive-Through",
  industry_cloud_kitchens: "Cloud Kitchens",

  industry_ac_hvac_repair: "AC & HVAC Repair",
  industry_car_wash_detailing: "Car Wash & Detailing",
  industry_electrical_services: "Electrical Services",
  industry_plumbing_maintenance: "Plumbing & Maintenance",
  industry_cleaning_services: "Cleaning Services",
  industry_delivery_logistics: "Delivery & Logistics",
  industry_moving_services: "Moving Services",
  industry_home_healthcare: "Home Healthcare",

  industry_gold_jewelry_short: "Gold & Jewelry",
  industry_fashion_clothing: "Fashion & Clothing",
  industry_grocery_stores: "Grocery Stores",
  industry_restaurants: "Restaurants",
  industry_wholesale_distribution: "Wholesale & Distribution",
  industry_hardware_tools: "Hardware & Tools",
  industry_beauty_cosmetics: "Beauty & Cosmetics",

  validation_error: "Validation Error",
  otp_validation_failed_try_again: "OTP validation failed. Try again.",

  // ZATCA — Seller Address (Saudi National Address)
  zatca_settings: "ZATCA Settings — Seller Address",
  zatca_settings_subtitle:
    "Required by ZATCA on every e-invoice. Used during device registration.",
  zatca_settings_helper_title: "Needed for e-invoicing",
  zatca_settings_helper:
    "All fields must be filled before you can enable ZATCA for a branch.",
  business_name_arabic: "Business Name in Arabic",
  street_name: "Street Name",
  plot_identification: "Plot ID",
  district: "District",
  address_sa_help: "Don't know these? Look them up at address.sa →",

  company_data_validation_failed:
    "Company data validation failed. Please complete all ZATCA seller-address fields before continuing.",

  // Store Configuration — section group titles & helper copy
  business_information: "Business Information",
  business_information_helper:
    "Core details about your business — visible on receipts and reports.",
  tax_compliance: "Tax & Compliance",
  tax_compliance_helper:
    "Registration numbers and certificates required for tax compliance.",
  business_address_details_helper:
    "Official business address used on invoices and business documents.",
  kindly_check_declaration:
    "Please check the declaration to confirm before proceeding.",

  // Logo management
  remove: "Remove",
  remove_logo: "Remove logo",
  confirm_remove_logo:
    "Are you sure you want to remove your business logo? Your saved logo will be deleted.",
  logo_removed: "Logo removed.",

  // ZATCA opt-in toggle
  zatca_enable_question: "Do you want to integrate ZATCA Phase 2 e-invoicing?",
  zatca_enable_helper:
    "Required for businesses issuing tax invoices in Saudi Arabia.",
  zatca_locked_helper:
    "ZATCA seller-address details have been submitted and can no longer be modified. Contact support if you need to make changes.",
  zatca_not_configured: "ZATCA e-invoicing is not enabled for this store.",
  zatca_not_configured_helper:
    "Open the edit form to turn on ZATCA Phase 2 and enter your seller-address details when you're ready.",

  // Page chrome
  zatca_onboarding: "ZATCA Onboarding",
  zatca_invoices: "ZATCA Invoices",
  zatca_invoice_issues: "ZATCA Invoice Issues",
  zatca_invoice_issues_failed: "Failed to load ZATCA invoice issues",
  issue_type: "Issue Type",
  issue_summary: "Issue Summary",
  search_invoice_issues_placeholder:
    "Search by invoice UUID, CR number, warning or error text",
  onboard_zatca: "Onboard ZATCA",
  enable_zatca: "Enable ZATCA",

  // Table columns / labels
  device_name: "Device Name",
  environment: "Environment",
  csid_expiry: "CSID Expiry",
  last_icv: "Last ICV",

  missing_fields: "Missing fields",

  // KYC pre-flight
  zatca_kyc_complete_title: "KYC address fields complete",
  zatca_kyc_incomplete_title: "Complete your ZATCA address first",
  zatca_kyc_incomplete_helper:
    "Some seller-address fields required by ZATCA are missing from your store profile. Open the store configuration to fill them in.",
  complete_zatca_address_fields: "Complete ZATCA address fields",

  env_sandbox: "Sandbox",
  env_simulation: "Simulation",
  env_production: "Production",

  get_your_otp: "Get your OTP",
  zatca_otp_instructions_helper:
    "Open fatoora.zatca.gov.sa → E-Invoice Onboarding → Generate OTP. Valid 1 hour.",
  copy_portal_url: "Copy portal URL",
  zatca_portal_url_copied: "Portal URL copied to clipboard.",
  otp_6_digits: "OTP (6 digits)",

  already_onboarded: "already onboarded for this environment",
  csid_expired: "CSID Expired",
  failed: "Failed",
  device_onboarded: "Device onboarded",
  zatca_onboard_success_helper:
    "ZATCA is now active for {{branch}} in {{environment}}.",
  zatca_onboard_failed_helper:
    "We couldn't onboard this device. Please verify the OTP and try again.",
  permission_required_title: "Permission required",
  zatca_permission_required_helper:
    "Only users with ZATCA permission can onboard devices. Ask your business owner to grant it in the Employee Permissions screen.",
  zatca_taking_longer_title: "ZATCA is taking longer than usual",
  zatca_taking_longer_helper:
    "The compliance checks are running. This will auto-retry — please don't close this window.",
  onboarded_at: "Onboarded at",
  device_uuid: "Device UUID",
  expiring_in_days_one: "Expires in {{count}} day",
  expiring_in_days_other: "Expires in {{count}} days",
  zatca_device_details: "ZATCA Device Details",
  zatca_device_detail_failed: "Unable to load ZATCA device details.",
  registered_by: "Registered By",
  invoices_count: "Invoices Count",
  csid_valid: "CSID Valid",
  production_request_id: "Production Request ID",
  compliance_request_id: "Compliance Request ID",
  last_pih: "Last PIH",
  renew_now: "Renew now",
  renew_csid: "Renew CSID",
  zatca_csid_renewed_title: "CSID renewed",
  zatca_csid_renewed_helper: "ZATCA CSID renewed successfully.",
  zatca_csid_renew_failed: "Unable to renew CSID.",
  zatca_get_otp_helper:
    "Open Fatoora portal, generate a new OTP, then enter it here.",
  copy: "Copy",
  copied: "Copied",
  devices_cannot_submit_banner_one:
    "{{count}} device cannot submit invoices until renewed.",
  devices_cannot_submit_banner_other:
    "{{count}} devices cannot submit invoices until renewed.",
  csid_expired_alert_helper:
    "This CSID has expired. Renew now to keep submitting invoices to ZATCA.",
  pending_onboarding: "Onboarding",
  compliance_pending: "Compliance check",
  compliance_passed: "Compliance passed",
  onboarding_in_progress: "Onboarding in progress",
  customer_type: "Customer Type",
  buyer_name: "Buyer Name",
  buyer_vat: "Buyer VAT",
  buyer_company_address: "Buyer Company Address",
  arabic_only_validation: "Only Arabic characters are allowed",

  buyer_information: "Buyer Information",
  buyer_company_information: "Buyer / Company Information",
  zatca: "ZATCA",

  invoices_last_7_days: "Invoices — last 7 days",
  zatca_invoices_empty_default_filter:
    "No rejected or failed invoices in the selected period — that's a good thing.",
  uuid: "UUID",
  subtype: "Subtype",
  when: "When",
  zatca_invoice_retry_attempt:
    "Retrying in {{minutes}} min (attempt {{n}}/{{max}})",

  download_xml: "Download signed XML",
  retry: "Retry",
  zatca_invoice_retry_disabled_helper:
    "The retry queue is still working on this one. The manual retry only opens after {{max}} automatic attempts.",
  zatca_invoice_retry_success: "Invoice queued for retry.",
  zatca_invoice_retry_failed: "Could not queue this invoice for retry.",
  zatca_invoice_xml_failed: "Could not download the signed XML.",

  // Status labels
  accepted: "Accepted",
  accepted_with_warnings: "Accepted (with warnings)",
  submitted: "Submitted",
  cleared: "Cleared",
  reported: "Reported",

  // Doc type / subtype labels
  invoice: "Invoice",
  credit_note: "Credit Note",
  debit_note: "Debit Note",

  zatca_subtype_standard: "B2B (Standard)",
  zatca_subtype_simplified: "B2C (Simplified)",

  // ─── Invoice Detail Drawer ───────────────────────────────────────
  invoice_detail: "Invoice details",
  zatca_errors: "ZATCA Errors",
  warnings: "Warnings",
  no_errors: "No errors reported by ZATCA.",
  no_warnings: "No warnings.",
  icv: "ICV",
  pih: "PIH",
  transaction: "Transaction",

  submitted_at: "Submitted at",
  zatca_invoice_qr_local: "Local QR (Phase 2 TLV)",
  zatca_invoice_qr_zatca: "ZATCA stamp QR (from cleared XML)",

  // ─── CSID Expiry Banner (Home dashboard) ─────────────────────────
  zatca_csid_banner_expired_one:
    "{{branch}} certificate expired {{days}} day ago. Invoices from this branch cannot be reported to ZATCA until renewed.",
  zatca_csid_banner_expired_other:
    "{{branch}} certificate expired {{days}} days ago. Invoices from this branch cannot be reported to ZATCA until renewed.",
  zatca_csid_banner_expiring_red:
    "{{branch}} certificate expires in {{days}} days — renew now to avoid downtime.",
  zatca_csid_banner_expiring_amber:
    "{{branch}} certificate expires in {{days}} days. Plan a renewal soon.",

  zatca_csid_banner_blocking_title:
    "This branch can't issue ZATCA invoices right now",
  zatca_csid_banner_blocking_helper:
    "The CSID has expired. Renew the certificate before completing any sale on this branch.",

  // ─── Onboarding Wizard — new pieces ──────────────────────────────

  zatca_onboarding_compliance_failed:
    "Some compliance checks failed. The ZATCA error messages are shown below verbatim — copy them when contacting support.",

  // ─── Sale Screen — B2B clearance UX ──────────────────────────────

  zatca_sale_clearance_failed_title: "ZATCA clearance failed",
  zatca_sale_clearance_failed_helper:
    "Start a new transaction. The invoice counter (ICV) for this attempt has already been used and cannot be reused.",
  zatca_sale_clearance_timeout_title: "ZATCA clearance timed out",
  zatca_sale_clearance_timeout_helper:
    "ZATCA is unreachable. Retry the same transaction, or fall back to a B2C receipt.",
  retry_clearance: "Retry clearance",
  clearance: "Clearance",
  reporting: "Reporting",
  issue_b2c_instead: "Issue B2C receipt instead",
  start_new_transaction: "Start new transaction",

  // ─── Receipt — disclosure / verification ─────────────────────────

  zatca_invoice_rejected_alert: "This invoice was rejected by ZATCA.",

  response_status: "Response Status",
  billing_reference: "Billing Reference",
  invoice_hash: "Invoice Hash",
  responded_at: "Responded At",
  updated_at: "Updated At",
  retry_count: "Retry Count",
  next_retry_at: "Next Retry At",
  compliance_check: "Compliance Check",

  same_cr_as_main_branch: "Same CR as main branch?",
  validate_same_cr_required: "Please select if this branch uses the same CR.",

  select_cr_number: "Select CR number",
  validate_name_or_phone_required: "Name or phone number is required",
  use_existing_branch_zatca: "Use ZATCA details from an existing branch?",
  validate_use_existing_branch_zatca:
    "Please select if you want to reuse ZATCA details from an existing branch.",
  add_new_cr_number: "Add a new CR number for this branch",

  onboarded: "Onboarded",
  needs_reonboarding: "Needs Re-onboarding",
  not_started: "Not Started",
  in_progress: "In Progress",
  zatca_reonboarding_confirm_title: "ZATCA re-onboarding required",
  zatca_reonboarding_confirm_message:
    "Updating ZATCA business details will require this branch to be onboarded again before issuing compliant invoices. Do you want to continue?",

  use_existing_cr_number: "Use existing CR number",
  select_zatca_cr_profile: "Select ZATCA CR profile",
  validate_select_zatca_cr_profile: "Please select a ZATCA CR profile.",
  zatca_cr_profile: "ZATCA CR Profile",
  branch_delete_zatca_history_error:
    "Branch cannot be deleted because it has ZATCA invoices in its history.",
  requires_reonboarding_at: "Requires Re-onboarding At",
  stale_reason: "Stale Reason",
  zatca_reonboarding_required_title: "ZATCA re-onboarding required",
  zatca_reonboarding_required_helper:
    "The seller CR profile changed. Re-onboard the affected device before issuing compliant invoices.",
  zatca_reonboarding_required_for_branch:
    "{{branch}} requires ZATCA re-onboarding. Reason: {{reason}}.",

  zatca_status: "ZATCA Status",
  zatca_branch_details: "ZATCA Branch Details",
  branch_information: "Branch Information",
  branch_address_details: "Branch Address Details",
  branch_address_details_helper:
    "Official branch address used on invoices and branch documents.",
  zatca_profile_details: "ZATCA Profile Details",
  company_id: "Company ID",

  profile_completed: "Profile completed",
  branches_count: "Branches count",
  linked_branches: "Linked branches",

  device_information: "Device Information",
  zatca_information: "ZATCA Information",
  technical_information: "Technical Information",
  profile_id: "Profile ID",
  version: "Version",
  branch_zatca_profile_details: "Branch ZATCA Profile Details",
  active_lock_key: "Active Lock Key",
  csr_content: "CSR Content",
  compliance_csid: "Compliance CSID",
  production_csid: "Production CSID",
  seller_information: "Seller Information",
  invoice_summary: "Invoice Summary",
  amount_summary: "Amount Summary",
  document_type: "Document Type",
  enter_otp: "Enter OTP",
  otp: "OTP",
  employee: "Employee",
  owner: "Owner",
  selected: "Selected",
  download_slip_pdf: "Download Slip in PDF",
  kiosk: "KIOSK",
  copy_failed: "Copy failed",
  dev_server: "Dev Server",
  qa_server: "QA Server",
  anypos_logo: "AnyPOS Logo",
  qr_code: "QR Code",
  payment_processing: "Payment Processing",
  success: "Success",
  loading: "Loading...",
  payment_type_mada: "Payment Type MADA",
  payment_type_visa: "Payment Type Visa",
  payment_type_mastercard: "Payment Type Mastercard",
  upload_units_categories_first: "First upload units and categories please.",
  failed_to_load_products: "Failed to load products",
  voice_connection_error: "Voice connection error. Please try again.",
  voice_session_inactive:
    "Voice assistant turned off after a pause. Tap the mic to start again.",
  voice_session_time_limit:
    "Voice assistant reached its time limit. Tap the mic to start again.",
  voice_agent_activated: "Voice agent activated! Start speaking.",
  failed_to_start_voice_agent: "Failed to start voice agent.",
  failed_to_start_voice_agent_retry:
    "Failed to start voice agent. Please try again.",
  failed_to_load_order_history: "Failed to load order history",
  order_confirmed: "Order Confirmed",
  voice_assistant: "Voice Assistant",
  touch_screen: "Touch Screen",
  ask_me_to_help_you_order: "Ask me to help you order",
  ready: "Ready",
  available_options: "Available Options:",
  report_invoice: "Report Invoice",
  clear_invoice: "Clear Invoice",
  zatca_invoice_report_success: "ZATCA Invoice Submitted",
  zatca_invoice_report_failed: "ZATCA Invoice Submission Failed",
  invoice_submitted_to_zatca: "Invoice submitted to ZATCA.",
  bulk_report_b2c_invoices: "Bulk Report B2C Invoices",
  bulk_report_selected_b2c_confirm:
    "Are you sure you want to report {{count}} selected B2C invoice(s) to ZATCA?",
  bulk_report_all_b2c_confirm:
    "No invoice is selected. This will report all pending/failed B2C invoices for the company. Are you sure?",
  bulk_report_b2c_success: "ZATCA bulk reporting dispatched",
  bulk_report_b2c_failed: "Failed to dispatch ZATCA bulk reporting",
  bulk_report_b2c_max_limit: "You can select a maximum of 500 invoices.",
  bulk_report_b2c_dispatched_count: "Dispatched {{count}} invoice(s).",
  zatca_temporarily_unavailable: "ZATCA temporarily unavailable",

  select_emoji: "Select Emoji",
  emoji: "Emoji",

  // Translation coverage
  unexpected_error_description:
    "An unexpected error occurred. Please reload the page and try again.",
  reload_page: "Reload page",
  checkout_total_must_be_greater_than_zero:
    "Total amount must be greater than 0.",
  phone_number_example: "e.g. +966 5xxxxxxx",
  licenses_used_summary: "Licenses used: {{used}} out of {{total}}",
  sold: "sold",
  addition: "Addition",
  subtraction: "Subtraction",
  multi_payment_cash: "Multi Payment Cash",
  multi_payment_card: "Multi Payment Card",
  qr_order: "QR Order",
  notifications: "Notifications",
  notification_sound_on: "Notification sound on",
  notification_sound_off: "Notification sound off",
  notification_sound_blocked:
    "Notification sound is blocked by your browser. Click anywhere on the page, or turn sound off and on.",
  notification_sound_failed:
    "Notification sound could not play. Check your device volume.",
  mark_all_as_read: "Read all",
  no_notifications: "No notifications yet",
  new_pending_qr_order: "New pending QR order {{orderNumber}}",
  pending_qr_order_notification_details: "Table {{table}} · Amount {{amount}}",
  table_management: "Table Management",
  order_management: "Order Management",
  waiter_management: "Waiter Management",
  job_management: "Job Management",
  stock_management: "Stock Management",
  surepay: "Surepay",
  customer_management: "Customer Management",
  error_in_row: "Error in row {{row}}: {{message}}",
  category_name_example: "Burger 🍔",
  transaction_reference: "Transaction Reference",
  payment_method: "Payment Method",
  amount_received: "Amount Received",
  remaining: "Remaining",
  buyer: "Buyer",
  transaction_code: "Transaction Code",
  issue_date: "Issue Date",
  item: "Item",
  unit_price: "Unit Price",
  printed_by_anypos: "Printed by anypos.ai",
  order_source: "Order Source",
  job_employee: "Job Employee",
  refund_invoice: "Refund Invoice",
  simplified_invoice: "Simplified Invoice",
  tax_invoice: "Tax Invoice",
  simplified_tax_invoice: "Simplified Tax Invoice",
  refund_invoice_no: "Refund Invoice No.",
  vat_exempt: "VAT Exempt",
  vat_total: "Total VAT",
  total_taxable_excluding_vat: "Total Taxable (Excluding VAT)",
  total_amount_due: "Total Amount Due",
  verifying_with_zatca: "Verifying with ZATCA…",
  rejected_by_zatca: "Rejected by ZATCA",
  error: "Error",
  warning: "Warning",
  saudi_arabia: "Saudi Arabia",

  // ─── Website Builder ──────────────────────────────────────────────
  website_appearance: "Appearance",
  website_brand: "Brand",
  website_brand_help:
    "Choose your brand color that will be displayed on your website",
  website_primary_colour: "Primary Colour",
  website_save_color: "Save Color",
  website_color_saved: "Color saved successfully",
  website_saved: "Website settings saved successfully",
  website_banners: "Banners",
  website_add_banner: "Add Banner",
  website_edit_banner: "Edit Banner",
  website_banner_title: "Banner Title",
  website_banner_title_placeholder: "e.g. Order fresh meals online",
  website_banner_title_required: "Banner title is required",
  website_banner_label: "Label",
  website_banner_label_placeholder: "e.g. New or Popular",
  website_banner_description_placeholder: "Add a short description",
  website_background_colour: "Background Color",
  website_banner_icon: "Icon",
  website_banner_image: "Banner Image",
  website_image_read_error: "The selected image could not be read",
  website_about: "About",
  website_section_heading: "Section Heading",
  website_section_heading_placeholder: "e.g. About our business",
  website_about_text: "About Company Text",
  website_about_text_placeholder: "Tell customers about your business",
  website_highlights: "Highlights",
  website_add_highlight: "Add Highlight",
  website_highlight_number: "Highlight {{number}}",
  website_highlight_placeholder: "Enter a key feature or benefit",
  phone_number_placeholder: "Enter a phone number",
  email_placeholder: "Enter an email address",
  address_placeholder: "Enter a business address",
  website_contact: "Contact",
  website_working_hours: "Working Hours",
  website_working_hours_help: "Set the opening and closing time for each day",
  website_day_sunday: "Sunday",
  website_day_monday: "Monday",
  website_day_tuesday: "Tuesday",
  website_day_wednesday: "Wednesday",
  website_day_thursday: "Thursday",
  website_day_friday: "Friday",
  website_day_saturday: "Saturday",
  website_open: "Open",
  website_closed: "Closed",
  website_to: "to",
  website_toggle_day: "Change availability for {{day}}",
  website_open_time_for: "Opening time for {{day}}",
  website_close_time_for: "Closing time for {{day}}",
  website_social: "Social Media",
  instagram: "Instagram",
  tiktok: "TikTok",
  facebook: "Facebook",
  x: "X",
  website_branches: "Branches",
  website_menu: "Menu",
  website_builder_sections: "Website Builder Sections",
  website_tip_title: "Brand Color Tip",
  website_tip_text:
    "The color you select here will be applied to important elements like buttons, links, and headings on your website.",
  website_hero_banners: "Hero Banners",
  website_hero_banners_help:
    "Add eye-catching banners at the top of your website",
  website_no_label: "No label",
  website_no_banners: "No banners added yet",
  website_about_section: "About Section",
  website_about_help:
    "Tell customers about your business, products, and services",
  website_highlights_help: "Add key features or benefits of your business",
  website_stats: "Stats (shown as highlight cards)",
  website_stats_help:
    "Add the numbers and labels you want to highlight about your business",
  website_stat_value: "Stat value {{number}}",
  website_stat_label: "Stat label {{number}}",
  website_stat_value_placeholder: "e.g. 50K+",
  website_stat_label_placeholder: "e.g. Happy Customers",
  website_contact_details: "Contact Information",
  website_social_help:
    "Add the social media links you want to show on your website",
  website_online_branches: "Online Branches",
  website_manage_branches: "Manage Branches",
  website_branches_help: "Select which branches to display on your website",
  website_no_branches: "No branches found",
  website_online_orders: "Online Orders",
  website_menu_visibility: "Menu Visibility",
  website_menu_help:
    "Preview your online menu and choose which products customers can see.",
  website_menu_categories: "Menu categories",
  website_menu_visibility_help:
    "Use each product switch to control what appears on your website.",
  website_show_category: "Show category on website",
  website_hide_category: "Hide category from website",
  website_toggle_category: "Change website visibility for {{category}}",
  website_all_products: "All Products",
  website_show_all_products: "Show all",
  website_hide_all_products: "Hide all",
  website_grid_view: "Grid view",
  website_list_view: "List view",
  website_product_visibility_help:
    "Choose which products should be visible on your storefront.",
  website_visible: "Visible",
  website_hidden: "Hidden",
  website_visible_of_total: "{{count}} of {{total}} visible",
  website_manage_products: "Manage Products",
  website_products: "Products",
  website_no_products: "No products found",
  website_no_categories: "No categories found",
  website_manage_menu: "Manage Menu",
  website_enabled: "Enabled",
  website_disabled: "Disabled",
  website_on: "ON",
  website_off: "OFF",
  choose_business: "Choose a business",
  choose_business_description:
    "Select the business account you want to continue with.",
  business_not_found: "Business not found",
  business_not_found_description:
    "This business URL does not exist. Check the address or use the main portal.",
  go_to_generic_portal: "Go to main portal",
  invalid_credentials: "Invalid phone number or password.",
  store_url: "Store URL",
  checking_store_url: "Checking availability...",
  store_url_available: "This store URL is available.",
  store_url_taken: "This store URL is already taken.",
  store_url_invalid: "Enter a valid store URL.",
  store_url_suggestions: "Suggestions",
  store_url_preview: "Your store URL",
  store_url_required: "Store URL is required.",
};

export default trans_en_GB;
